import { FC } from 'react';

import { Icon, IconName, Size } from '@purpur/library/icon';

import { getSvgIcon } from '@telialt/common-icon/src';

import { SPECIAL_OFFERS_TEST_ID } from '../../test-ids';
import { RoundFilledIconWrapper } from './RoundFilledIcon.styles';

export type RoundFilledIconVariant = 'default' | 'info';

type Props = { icon?: IconName | string; size: Size; variant?: RoundFilledIconVariant };

export const RoundFilledIcon: FC<Props> = ({ icon, size, variant = 'default' }) => {
    const svg = getSvgIcon(icon);

    return (
        <RoundFilledIconWrapper $variant={variant} data-test={SPECIAL_OFFERS_TEST_ID.ROUND_FILLED_ICON}>
            <Icon svg={svg} size={size} />
        </RoundFilledIconWrapper>
    );
};
